import { Layout } from "antd";

import { useGetAssetType } from "@/entities/asset-type";
import { PageItemGate } from "@/modules/page-item-gate";
import { useIdParam } from "@/services/router";

import { AssetTypePageHeader } from "./asset-type-page-header";
import { AssetTypePageTabs } from "./asset-type-page-tabs";

const { Content } = Layout;

const AssetTypePage = () => {
  const id = useIdParam();

  const { isLoading, assetType, error } = useGetAssetType(id);

  return (
    <PageItemGate model="assettype" queryError={error}>
      <AssetTypePageHeader assetType={assetType} loading={isLoading} />
      <Content>
        <AssetTypePageTabs assetType={assetType} loading={isLoading} />
      </Content>
    </PageItemGate>
  );
};

export default AssetTypePage;
